import React, { useEffect, useState } from 'react'
import DashboardContainer from '../../components/dashboard-container'
import CircularProgress from '@mui/material/CircularProgress'
import { Box } from '@mui/material'
import CustomPagination from '../../components/pagination'
import { shippingServiceService } from '../../utils/services/shippingService'
import ShippingServiceModal from '../../components/shipping-service-modal'
import ShippingServiceList from '../../components/shipping-service-list'

export default function ShippingService() {
  const [shippingServiceData, setShippingServiceData] = useState([])
  const [selectedService, setSelectedService] = useState(null)
  const [loading, setLoading] = useState(false)
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(15)
  const [dataCount, setDataCount] = useState(rowsPerPage)
  const [openModal, setOpenModal] = useState(false)
  const [searchValue, setSearchValue] = useState('')
  const [clientFilter, setClientFilter] = useState(null)
  const clientId = localStorage.getItem('client_id')
  const [viewMode, setViewMode] = useState('list')

  const fetchShippingServiceMapData = async () => {
    setLoading(true)
    try {
      const skip = page * rowsPerPage
      const response = await shippingServiceService.fetch(
        rowsPerPage,
        skip,
        clientId ? clientId : clientFilter?._id,
        searchValue
      )
      setShippingServiceData(response.data)
      setDataCount(response?.total)
    } catch (error) {
      console.error('Fetch failed:', error)
      // Handle fetch failure
    } finally {
      setLoading(false)
    }
  }
  useEffect(() => {
    fetchShippingServiceMapData()
  }, [page, rowsPerPage, clientFilter, searchValue])

  const NoDataImage = () => (
    <div
      style={{
        width: '100%',
        justifyContent: 'center',
        display: 'flex'
      }}
    >
      <img src="no_data.png" alt="No data available" style={{ objectFit: 'cover', height: '340px' }} />
    </div>
  )

  return (
    <DashboardContainer
      searchBarPlaceholder={'Search by service'}
      hideFilterClient
      onSearchData={(x) => {
        setSearchValue(x)
        setPage(0)
      }}
      onClickAddButton={() => setOpenModal(true)}
      hideUploadButton={true}
      header={'Shipping Service List'}
      onSelectClient={(e) => {
        setClientFilter(e)
      }}
      title={'+ Add Shipping Service'}
      setViewMode={setViewMode}
    >
      <ShippingServiceModal
        selectedService={selectedService}
        handleClose={() => {
          setOpenModal(false)
          setSelectedService(null)
        }}
        open={openModal}
        onAddData={fetchShippingServiceMapData}
      />

      {loading && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: 9999,
            color: 'white'
          }}
        >
          <CircularProgress color="inherit" />
        </Box>
      )}

      {shippingServiceData.length === 0 ? (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%'
          }}
        >
          <NoDataImage />
        </div>
      ) : (
        <ShippingServiceList
          onDeleteData={() => fetchShippingServiceMapData()}
          onEditData={(e) => {
            setSelectedService(e)
            setOpenModal(true)
          }}
          data={shippingServiceData}
          viewMode={viewMode}
          deleteTitle={'Delete Port'}
          selectedService={selectedService}
          setSelectedShippingService={setSelectedService}
          currentPage={page}
          itemsPerPage={rowsPerPage}
        />
      )}

      <CustomPagination
        dataCount={dataCount}
        rowsPerPage={rowsPerPage}
        page={page}
        setPage={setPage}
        setRowsPerPage={setRowsPerPage}
        disableNext={dataCount <= rowsPerPage * (page + 1)}
      />
    </DashboardContainer>
  )
}
